import { Component } from 'react';


class IteamFooterContainer extends Component {

    render() {
        return (
            <div id='iTeamFooter' className='iTeamFooterContainer'>
                <div id='iTeamFooterPlaceHolder' className='iTeamFooterPlaceHolder'></div>
                {this.props.children}
            </div>
        );
    }
}


export default IteamFooterContainer;
